// src/utils/mediaQueries.js
export const breakpoints = {
  desktop: "(min-width: 1224px)",
  bigScreen: "(min-width: 1824px)",
  tablet: "(max-width: 1224px)",
  mobile: "(max-width: 767px)",
  portrait: "(orientation: portrait)",
  retina: "(min-resolution: 2dppx)",
};
